import { Box, FormControl, Grid, InputLabel, Slider } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'

import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { FilterByColumnSettings } from '../../types'
import InputNumber from './InputNumber'

function GreaterThanOrEqual({
  filterSettings,
  onChange
}: {
  filterSettings: FilterByColumnSettings
  onChange: (filterSettings: FilterByColumnSettings) => void
}) {
  const [number, setNumber] = useState(filterSettings?.filterNumberFirst)
  const columnStats = useAppSelector((state) => state.analysis.columnStats)
  const columnStatsStatus = useAppSelector((state) => state.analysis.columnStatsStatus)
  const max = columnStats?.max
  const min = columnStats?.min

  const handleChange = (e, newValue) => {
    setNumber(newValue)
    const newState = { ...filterSettings, filterNumberFirst: newValue }
    onChange(newState)
  }

  return (
    <FormControl size="small" margin="normal">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <InputLabel id={`analysis-numbers-slide-label`} variant="outlined">
            <FormattedMessage id="analysis.columnValue.numberFilter.input.slide" />
          </InputLabel>
          <Box ml={1} mr={0.5}>
            <Slider
              track="inverted"
              min={min}
              max={max}
              name="analysis-numbers-slide-greater-label"
              disabled={columnStatsStatus === RequestStatus.Pending}
              value={number || 0}
              onChange={handleChange}
            />
          </Box>
        </Grid>
        <Grid container spacing={1} justifyContent="space-between" ml={0.5}>
          <Grid item xs={4}>
            <InputNumber
              number={number}
              adornment="≥"
              onChange={(value) => {
                setNumber(value)
                onChange({ ...filterSettings, filterNumberFirst: value })
              }}
            />
          </Grid>
          <Grid item style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage id="analysis.columnValue.numberFilter.input.max" />
              <strong> {max}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default GreaterThanOrEqual
